import React from 'react'
import { useState, useEffect,useRef} from 'react'
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import AssignedAds from "./AssignedAds";
import ProgressAds from "./ProgressAds";
import CompleteAds from "./CompleteAds";
import AbortAds from './AbortAds';
import { useTableState } from './utils/useTableState';
import api from "../../services/api";
import config from "../../config";
import { Toast } from "../../shared/Toast";
import { registerSW } from '../../utils/pushSubscription';
import Datepicker from 'react-tailwindcss-datepicker';
import Select from 'react-select';

const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
]

const Home = () => {
  
  const [loader,setloader] = useState(false);

  const { currentPage, setCurrentPage, handlePageChange } = useTableState();
  // shared filter state lifted from children
  const today = new Date().toISOString().split('T')[0];
  const [dateRange, setDateRange] = useState({startDate:null,endDate:null});
  const dateRangeRef = useRef(dateRange);

  const [adType, setAdType] = useState(null);
  const [search, setSearch] = useState('');
  const adTypeRef = useRef(adType);
  const searchRef = useRef(search);

  const [currentChild, setcurrentChild] = useState('assigned-Ads');

  const [assignedDesigns, setassignedDesigns] = useState([]);
  const [totalassigned, settotalassigned] = useState(0);

  const [progressDesigns, setprogressDesigns] = useState([]);
  const [totalprogress, settotalprogress] = useState(0);
  const [initialcount,setinitialcount] = useState(0);
  const [rejectedcount,setrejectedcount] = useState(0);
  const [progressseletedtab,setprogressseletedtab] = useState('initial');

  const [completeDesigns, setcompleteDesigns] = useState([]);
  const [totalcomplete, settotalcomplete] = useState(0);
  const [NotAcceptedCount,setnotacceptedcount] = useState(0);
  const [AcceptedCount,setacceptedcount] = useState(0);
  const [completeselectedtab,setcompleteselectedtab] = useState('Pending_Approval')

  const [abortDesigns,setabortDesigns] =useState([]);
  const [totalabort,settotalabort] = useState(0);

  const tabGroupRef = useRef(null);
  
  const handleTabSwitch = (panelName) => {
    setDateRange({startDate:null,endDate:null});
    setAdType(null);
    setSearch('');
    tabGroupRef.current?.show(panelName);
  };

  // now accepts filters
  const getassignedDesigns = async (page, dateRange, adType, search) => {
    try {
      setloader(true);
      let res = await api({
        url: `/user/designer/getAssignedDesignes`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || ''
        }
      });
      if (res.code === 200) {
        setassignedDesigns(res.data?.data);
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  const totalCount = async(dateRange,search,adType)=>{
    try {
      let res = await api({
        url: `/user/designer/getTotalCount`,
        method: "POST",
        responseType: "json",
        data: {
          start_date: dateRange?.startDate || null,
          end_date: dateRange?.endDate || null,
          ad_type: adType?.value || null,
          query: search || ''
        }
      });
      if (res.code === 200) {
        settotalassigned(res.data.find(item => item.status === 2)?.total);
        const progress = res.data
        .filter(item => item.status === 3)
        .reduce((sum, item) => sum + Number(item.total), 0);
        settotalprogress(progress);

        setnotacceptedcount(res.data.find(item => item.status === 4)?.total ?? 0);
        const accepted = res.data.filter(item => item.status > 4).reduce((sum,item)=>sum + Number(item.total),0);
        setacceptedcount(accepted);
  
      const complete = res.data
        .filter(item => item.status >= 4 )
        .reduce((sum, item) => sum + Number(item.total), 0);
      settotalcomplete(complete);

      setinitialcount(res.data.find(item => item.status == "initial")?.total);
      setrejectedcount(res.data.find(item=>item.status == "rejected")?.total);
      settotalabort(res.data.find(item => item.status === "abort")?.total);
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  
  useEffect(() => {
    dateRangeRef.current = dateRange;
    searchRef.current = search;
    adTypeRef.current = adType;
  }, [dateRange,adType,search]);

  useEffect(() => {
    registerSW();
    const interval = setInterval(() => {
      totalCount(dateRangeRef.current,searchRef.current,adTypeRef.current); // always latest value
    }, 10000);
  
    return () => clearInterval(interval);
  }, []); 

  const pickDesign = async (creative_id) => {
    try {
      let res = await api({
        url: `/user/designer/pickDesign`,
        method: "POST",
        responseType: "json",
        data: {
          creative_id
        }
      });
      if (res.code === 200) {
        Toast('success',"Design picked successfully");
        handleTabSwitch('progress-Ads')
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  // now accepts filters for server‐side filtering
  const getprogressDesigns = async (page, dateRange, adType, search) => {
    try {
      setloader(true);
      if(progressseletedtab == 'initial')
      {
        let res = await api({
          url: `/user/designer/getProgressDesignes`,
          method: "POST",
          responseType: "json",
          data: {
            page,
            limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || ''
          }
        });
        if (res.code === 200) {
          setprogressDesigns(res.data?.data);
        }
      }
      else
      {
        let res = await api({
          url: `/user/designer/getRejectedDesigns`, //Table data
          method: "POST",
          responseType: "json",
          data: {
            page,
            limit: config.PER_PAGE,
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            ad_type: adType?.value || null,
            query: search || ''
          }
        })
        if (res.code === 200) {
          setprogressDesigns(res.data?.data);
        }     
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  // now accepts filters
  const getcompletedDesigns = async (page, dateRange, adType, search) => {
    try {
      setloader(true);
      if(completeselectedtab == 'Pending_Approval')
      {
        let res = await api({
          url: `/user/designer/getClientNotAcceptedDesigns`, //Table data
          method: "POST",
          responseType: "json",
          data: {
            page,
            limit: config.PER_PAGE,
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            ad_type: adType?.value || null,
            query: search || ''
          }
        })
        if (res.code === 200) {
          setcompleteDesigns(res.data?.data);
        }        
      }
      else
      {
        let res = await api({
          url: `/user/designer/getCompletedDesignes`,
          method: "POST",
          responseType: "json",
          data: {
            page,
            limit: config.PER_PAGE,
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            ad_type: adType?.value || null,
            query: search || ''
        }
        });
        if (res.code === 200) {
          setcompleteDesigns(res.data?.data);
        } 
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  // now accepts filters
  const getAbortedDesigns = async (page, dateRange, adType, search) => {
    try {
      setloader(true);
      let res = await api({
        url: `/user/designer/getAbortedDesigns`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || ''
        }
      });
      if (res.code === 200) {
        setabortDesigns(res.data?.data);
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
    const handleDateChange = (val) => {
    setDateRange(val);
    setCurrentPage(0);
  };
  const handleAdTypeChange = (val) => {
    setAdType(val);
    setCurrentPage(0);
  };
  const handleSearchChange = (e) => {
    const q = e.target.value;
    setSearch(q);
    setCurrentPage(0);
  };
  useEffect(() => {
    totalCount(dateRange,search,adType);
    console.log("mounted here")
    // invoke fetch with shared filters
    if (currentChild === 'assigned-Ads')
      getassignedDesigns(currentPage, dateRange, adType, search);
    else if (currentChild === 'progress-Ads')
      getprogressDesigns(currentPage, dateRange, adType, search);
    else if (currentChild === 'complete-Ads')
      getcompletedDesigns(currentPage, dateRange, adType, search);
    else
      getAbortedDesigns(currentPage, dateRange, adType, search);
  }, [currentChild, currentPage, dateRange, adType, search,progressseletedtab,completeselectedtab]);
 
  return (
    <div style={{ padding: '20px' }}>
      <SlTabGroup
        ref={tabGroupRef} 
        onSlTabShow={(event) => {
          const panelName = event.detail.name;
          setcurrentChild(panelName);
          setDateRange({startDate:null,endDate:null});
          setAdType(null);
          setSearch('');
        }}>
        <SlTab slot="nav" panel="assigned-Ads">Assigned Designs <span className='text-blue-600 mx-1'> {totalassigned || 0} </span></SlTab>
        <SlTab slot="nav" panel="progress-Ads">Progress Designs <span className='text-blue-600 mx-1'> {totalprogress || 0}</span></SlTab>
        <SlTab slot="nav" panel="complete-Ads">Complete Designs <span className='text-blue-600 mx-1'> {totalcomplete || 0}</span></SlTab>
        <SlTab slot="nav" panel="abort-Ads">Abort Designs <span className='text-blue-600 mx-1'>{totalabort || 0}</span></SlTab>
        <div className="flex flex-wrap gap-4 m-4 items-end">
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Start Date Range</label>
          <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
            <Datepicker
              value={dateRange}
              onChange={handleDateChange}
              primaryColor="cyan"
              showShortcuts={true}
              classNames="form-input"
              asSingle={false}
            />
          </div>
        </div>
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Search</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            placeholder="Search by campaign/brand/client"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Ad Type</label>
          <Select
            options={types}
            value={adType}
            onChange={handleAdTypeChange}
            isClearable
            placeholder="Select Ad Type"
            classNamePrefix="react-select"
          />
        </div>
        </div>
        <SlTabPanel name="assigned-Ads">
          <AssignedAds
            pickDesign={pickDesign}
            assignedDesigns={assignedDesigns}
            getassignedDesigns={getassignedDesigns}
            setassignedDesigns={setassignedDesigns}
            totalassigned={totalassigned}
            settotalassigned={settotalassigned}
            activechild={currentChild}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader = {loader}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="progress-Ads">
          <ProgressAds
            getprogressDesigns={getprogressDesigns}
            progressDesigns={progressDesigns}
            setprogressDesigns={setprogressDesigns}
            totalprogress={totalprogress}
            settotalprogress={settotalprogress}
            activechild={currentChild}
            loader = {loader}
            tabswitch = {handleTabSwitch}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            progressseletedtab={progressseletedtab}
            setprogressseletedtab={setprogressseletedtab}
            initialcount={initialcount}
            rejectedcount={rejectedcount}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="complete-Ads">
          <CompleteAds
            getcompletedDesigns={getcompletedDesigns}
            completeDesigns={completeDesigns}
            setcompleteDesigns={setcompleteDesigns}
            totalcomplete={totalcomplete}
            settotalcomplete={settotalcomplete}
            activechild={currentChild}
            loader = {loader}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            completeselectedtab={completeselectedtab}
            setcompleteselectedtab={setcompleteselectedtab}
            NotAcceptedCount={NotAcceptedCount}
            AcceptedCount={AcceptedCount}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="abort-Ads">
          <AbortAds
            abortDesigns = {abortDesigns}
            getAbortedDesigns={getAbortedDesigns}
            getassignedDesigns={getassignedDesigns}
            setabortDesigns={setabortDesigns}
            totalabort={totalabort}
            settotalabort={settotalabort}          
            activechild={currentChild}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader = {loader}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
      </SlTabGroup>
    </div>
  )
}

export default Home